import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaShareAlt,
  FaWhatsapp,
} from 'react-icons/fa';
import auditManagementImage from '../../assets/images/Blogs/AuditManagement/auditManagement.PNG';
import configureStoreImage from '../../assets/images/Blogs/ConfigureStoreImage/configureStore.PNG';
import logicalObjectImage from '../../assets/images/Blogs/LogicalObject/LogicalObjectDiagram.PNG';
import reactiveLoggingImage from '../../assets/images/Blogs/Thumbnails/reactive-logging.jpg';
import securityPropagationImage from '../../assets/images/Blogs/Thumbnails/security-propagation.jpg';
import teamcenterAdminDataImage from '../../assets/images/Blogs/Thumbnails/teamcenter-11-admin-data.jpg';
import securityModelTestingImage from '../../assets/images/Blogs/Thumbnails/security-model-testing-generated.png';
import uploadDownloadFilesImage from '../../assets/images/Blogs/Thumbnails/upload-download-files-generated.png';
import teamcenterXImage from '../../assets/images/Blogs/Thumbnails/teamcenter-x-cloud-generated.png';
import blogMetadata from '../../data/blogMetadata.json';




const BlogWrapper = styled.div`
  margin-top: 50px;
  text-align: center;

  h1 {
    font-size: 3rem;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 40px;
  }

  .blog-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: #ffffff;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s, box-shadow 0.3s;
    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 16px 30px rgba(0, 0, 0, 0.15);
    }

    img {
      width: 100%;
      height: 250px;
      object-fit: cover;
      transition: opacity 0.3s;
      &:hover {
        opacity: 0.9;
      }
    }

    .card-body {
      flex: 1;
      padding: 1.5rem;
    }

    .card-link,
    .card-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      color: inherit;
      text-decoration: none;
    }

    .card-title {
      font-size: 1.4rem;
      text-align: left;
      font-weight: 700;
      color: #34495e;
      margin-bottom: 10px;
    }

    .card-text {
      font-size: 1rem;
      color: #7f8c8d;
      line-height: 1.5;
      text-align: justify;
    }

    .share-control {
      position: absolute;
      top: 14px;
      right: 14px;
      z-index: 4;
    }

    .share-trigger {
      width: 42px;
      height: 42px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 0;
      border-radius: 50%;
      color: #ffffff;
      background: #0b4a7d;
      box-shadow: 0 5px 14px rgba(0, 0, 0, 0.24);
      cursor: pointer;
      transition: transform 0.2s ease, background-color 0.2s ease;

      &:hover,
      &:focus-visible {
        background: #087bbd;
        transform: scale(1.06);
      }

      &:focus-visible {
        outline: 3px solid rgba(255, 255, 255, 0.95);
        outline-offset: 2px;
      }
    }

    .share-menu {
      position: absolute;
      top: 50px;
      right: 0;
      width: min(230px, calc(100vw - 48px));
      padding: 10px;
      border: 1px solid #dce5ec;
      border-radius: 12px;
      background: #ffffff;
      box-shadow: 0 14px 32px rgba(13, 47, 71, 0.22);
      text-align: left;
    }

    .share-action {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 9px 10px;
      border: 0;
      border-radius: 8px;
      color: #34495e;
      background: transparent;
      font: inherit;
      font-size: 0.92rem;
      text-decoration: none;
      cursor: pointer;

      svg {
        width: 17px;
        flex: 0 0 17px;
        color: #087bbd;
      }

      &:hover,
      &:focus-visible {
        color: #0b4a7d;
        background: #edf7fc;
        outline: none;
      }
    }

    .copy-status {
      margin: 5px 8px 1px;
      color: #238636;
      font-size: 0.78rem;
      font-weight: 600;
    }
  }

  .row {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
  }

  NavLink {
    text-decoration: none;
  }

    .col-md-4 {
    flex: 0 0 calc(33.33% - 20px); /* Take up 1/3 of the row and account for the gap */
  }
  @media (max-width: 768px) {

    .col-md-4 {
      flex: 0 0 calc(50% - 20px); /* Take up 50% width on smaller screens */
    }
    .blog-card {
      margin-bottom: 30px;
    }

    h1 {
      font-size: 2.5rem;
    }
  }

  @media (max-width: 576px) {
    margin-top: 32px;

    h1 {
      margin-bottom: 28px;
      font-size: 2rem;
      line-height: 1.2;
    }

    .row {
      gap: 0;
    }

    .col-md-4 {
      width: 100%;
      max-width: 100%;
      flex: 0 0 100%;
    }

    .blog-card {
      margin-bottom: 22px;

      &:hover {
        transform: none;
      }

      img {
        height: 220px;
      }

      .card-body {
        padding: 1.25rem;
      }

      .card-title {
        font-size: 1.25rem;
      }

      .share-control {
        top: 12px;
        right: 12px;
      }

      .share-trigger {
        width: 44px;
        height: 44px;
      }

      .share-menu {
        top: 52px;
        padding: 8px;
      }

      .share-action {
        min-height: 44px;
        padding: 10px;
      }
    }
  }
`;

const SITE_URL = 'https://nextechplm.com';
const LINKEDIN_COMPOSER_URL = 'https://www.linkedin.com/feed/?shareActive=true';

const openShareWindow = (url) => {
  return window.open(url, '_blank', 'noopener,noreferrer,width=720,height=640');
};

const prepareLinkedInComposerWindow = () => {
  const composerWindow = window.open('about:blank', '_blank', 'width=720,height=640');
  if (composerWindow) {
    composerWindow.opener = null;
    composerWindow.document.title = 'Preparing LinkedIn image post';
    composerWindow.document.body.textContent = 'Preparing the full-size image for LinkedIn...';
  }
  return composerWindow;
};

const getSocialImageUrl = (path) => {
  const post = Object.values(blogMetadata.posts).find(
    (entry) => entry.canonicalPath.toLowerCase() === path?.toLowerCase()
  );
  const imagePath = post?.ogImage || blogMetadata.fallbackImage.path;
  return `${SITE_URL}${imagePath}`;
};

const ShareMenu = ({ title, path, slug }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [copyStatus, setCopyStatus] = useState('');
  const controlRef = useRef(null);
  const shareUrl = `${SITE_URL}${path || `/blog#${slug}`}`;
  const socialImageUrl = getSocialImageUrl(path);
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedMessage = encodeURIComponent(`${title} - ${shareUrl}`);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleOutsideClick = (event) => {
      if (!controlRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  const toggleMenu = () => {
    setCopyStatus('');
    setIsOpen((current) => !current);
  };

  const copyText = async (text, message) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      textArea.remove();
    }
    setCopyStatus(message);
  };

  const copyShareUrl = (message) => copyText(shareUrl, message);

  const handleNativeShare = async (fallbackMessage) => {
    if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
      try {
        await navigator.share({
          title,
          text: `Read ${title} from NexTech PLM Solutions.`,
          url: shareUrl,
        });
        setIsOpen(false);
        return;
      } catch (error) {
        if (error?.name === 'AbortError') return;
      }
    }

    await copyShareUrl(fallbackMessage);
  };

  const downloadSocialImage = (blob) => {
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = `${slug || 'nextech-plm'}-linkedin.png`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  };

  const handleLinkedInImageShare = async () => {
    setCopyStatus('Preparing the full-size image...');

    let nativeFileShareAvailable = false;
    if (
      typeof navigator !== 'undefined'
      && typeof navigator.share === 'function'
      && typeof navigator.canShare === 'function'
      && typeof File === 'function'
    ) {
      try {
        const capabilityProbe = new File([], 'linkedin-image.png', { type: 'image/png' });
        nativeFileShareAvailable = navigator.canShare({ files: [capabilityProbe] });
      } catch (error) {
        nativeFileShareAvailable = false;
      }
    }

    const preparedComposerWindow = nativeFileShareAvailable
      ? null
      : prepareLinkedInComposerWindow();

    try {
      const response = await fetch(socialImageUrl, { cache: 'no-store' });
      if (!response.ok) {
        throw new Error(`Image request failed with status ${response.status}`);
      }

      const blob = await response.blob();
      if (!blob.type.startsWith('image/')) {
        throw new Error('The social image response is not an image.');
      }

      const postText = `${title}\n\nRead the full article: ${shareUrl}`;
      if (nativeFileShareAvailable) {
        const file = new File([blob], `${slug || 'nextech-plm'}-linkedin.png`, {
          type: blob.type || 'image/png',
        });
        const fileShare = {
          files: [file],
          title,
          text: postText,
          url: shareUrl,
        };
        try {
          await navigator.share(fileShare);
          setCopyStatus('The full image was sent to the selected app as media.');
          setIsOpen(false);
          return;
        } catch (error) {
          if (error?.name === 'AbortError') {
            setCopyStatus('Sharing cancelled.');
            return;
          }
          // If the browser advertises file sharing but rejects the real file,
          // continue into the download-and-upload media workflow below.
        }
      }

      downloadSocialImage(blob);
      await copyText(
        postText,
        'Full image downloaded and caption copied. In LinkedIn, choose Media, upload the downloaded PNG, then paste the caption.'
      );
      if (preparedComposerWindow && !preparedComposerWindow.closed) {
        preparedComposerWindow.location.replace(LINKEDIN_COMPOSER_URL);
      } else {
        openShareWindow(LINKEDIN_COMPOSER_URL);
      }
    } catch (error) {
      if (preparedComposerWindow && !preparedComposerWindow.closed) {
        preparedComposerWindow.close();
      }
      if (error?.name === 'AbortError') {
        setCopyStatus('Sharing cancelled.');
        return;
      }

      setCopyStatus('The full image could not be prepared. Please check your connection and try again.');
    }
  };

  const shareTargets = [
    {
      label: 'Linkedin',
      icon: <FaLinkedinIn aria-hidden="true" />,
      onClick: handleLinkedInImageShare,
    },
    {
      label: 'Facebook',
      icon: <FaFacebookF aria-hidden="true" />,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    },
    {
      label: 'Instagram',
      icon: <FaInstagram aria-hidden="true" />,
      onClick: () => handleNativeShare('Link copied — paste it into Instagram.'),
    },
    {
      label: 'WhatsApp',
      icon: <FaWhatsapp aria-hidden="true" />,
      url: `https://api.whatsapp.com/send?text=${encodedMessage}`,
    },
  ];

  const handleShareTarget = (target) => {
    if (target.onClick) {
      target.onClick();
      return;
    }

    openShareWindow(target.url);
    setIsOpen(false);
  };

  return (
    <div className="share-control" ref={controlRef}>
      <button
        type="button"
        className="share-trigger"
        aria-label={`Share ${title}`}
        aria-expanded={isOpen}
        aria-haspopup="menu"
        onClick={toggleMenu}
      >
        <FaShareAlt aria-hidden="true" />
      </button>
      {isOpen && (
        <div className="share-menu" role="menu" aria-label={`Share ${title}`}>
          {shareTargets.map((target) => (
            <button
              type="button"
              className="share-action"
              role="menuitem"
              key={target.label}
              onClick={() => handleShareTarget(target)}
            >
              {target.icon}
              <span>{target.label}</span>
            </button>
          ))}
          <button
            type="button"
            className="share-action"
            role="menuitem"
            onClick={() => handleNativeShare('Link copied — share it in any app.')}
          >
            <FaShareAlt aria-hidden="true" />
            <span>More apps</span>
          </button>
          {copyStatus && <p className="copy-status" role="status">{copyStatus}</p>}
        </div>
      )}
    </div>
  );
};
const blogPosts = [
  {
    title: 'Audit Management',
    text: 'As PLM expands its scope across the enterprise, tracking what happened to data becomes increasingly important!',
    image: auditManagementImage,
    alt: 'Audit management Teamcenter screen preview',
    to: '/blog/audit-management',
    slug: 'audit-management',
  },
  {
    title: 'Configure Store and Forward',
    text: 'Global company operations require sharing high volumes of business data seamlessly.',
    image: configureStoreImage,
    alt: 'Configure store and forward workflow preview',
    to: '/blog/Configure-Store-and-Forward',
    slug: 'configure-store-and-forward',
  },
  {
    title: 'Logical Object Post',
    text: 'Logical objects consolidate properties from related objects into a single, simplified structure.',
    image: logicalObjectImage,
    alt: 'Logical object data structure diagram preview',
    to: '/blog/Logical-object-post',
    slug: 'logical-object-post',
  },
  {
    title: 'Siemens Teamcenter now Supports Automation of your security model testing',
    text: 'Security problems create more challenges in protecting sensitive information data in PLM, making automated security model testing increasingly useful.',
    image: securityModelTestingImage,
    alt: 'Server infrastructure for security model testing article',
    slug: 'security-model-testing',
    to: '/blog/security-model-testing', // <--- MAKE SURE THIS IS HERE
  },
  {
    title: 'Siemens Teamcenter now Supports Upload and Download of Files Rev1',
    text: 'It is a common business scenario where you need to upload or download large files such as MS Word documents, CAE result files, and other Teamcenter datasets.',
    image: uploadDownloadFilesImage,
    alt: 'Data transfer complete screen for upload and download files article',
    slug: 'upload-download-files',
    to: '/blog/upload-download-files', // <--- MAKE SURE THIS IS HERE
  },
 {
    title: 'Teamcenter X: The Future of PLM Is in the Cloud',
    text: 'Discover Teamcenter X, Siemens cloud-native SaaS PLM solution. Learn about its modular tiers, AI Copilot, and scalability.',
    image: teamcenterXImage,
    alt: 'Teamcenter X Cloud PLM',
    slug: 'teamcenter-x',
    to: '/blog/teamcenter-x',
  },
  {
    title: 'Reactive Logging',
    text: 'Reactive logging in Active Workspace enables regular users to generate logs reactively for issues they observe while performing a specific business use case.',
    image: reactiveLoggingImage,
    alt: 'System monitoring dashboard for reactive logging article',
    slug: 'reactive-logging',
    to: '/blog/reactive-logging', // <--- Add this link
  },
  {
    title: 'Security propagation',
    text: 'It is a very common business scenario where you need to copy property values from one object to related objects such as item revisions, datasets, and forms.',
    image: securityPropagationImage,
    alt: 'Digital security screen for security propagation article',
    slug: 'security-propagation',
    to: '/blog/security-propagation', // Ensure this line exists!
  },
  {
    title: 'Siemens Teamcenter 11',
    text: 'Siemens Teamcenter 11.2 enables teams to manage and share admin data across PLM environments efficiently with export, import, synchronize, compare, and analyze capabilities.',
    image: teamcenterAdminDataImage,
    alt: 'Analytics monitor for Siemens Teamcenter admin data article',
    slug: 'siemens-teamcenter-11',
    to: '/blog/siemens-teamcenter-11', // <--- Add this link
  },
];


const Blog = () => {
  return (
    <BlogWrapper className="container">
      <h1>Our Latest Blog Posts</h1>
      <div className="row">
        {blogPosts.map((post) => {
          const cardContent = (
            <div className="card-content">
              <img src={post.image} alt={post.alt} />
              <div className="card-body">
                <h5 className="card-title">{post.title}</h5>
                <p className="card-text">{post.text}</p>
              </div>
            </div>
          );

          return (
            <div className="col-md-4 col-lg-4 mb-4" key={post.title}>
              <article className="blog-card" id={post.slug}>
                {post.to ? (
                  <NavLink className="card-link" to={post.to}>
                    {cardContent}
                  </NavLink>
                ) : cardContent}
                <ShareMenu title={post.title} path={post.to} slug={post.slug} />
              </article>
            </div>
          );
        })}
      </div>
    </BlogWrapper>
  );
};

export default Blog;
